import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex items-center mt-4" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "capitalize",
  disabled: ""
}
const _hoisted_4 = { class: "block my-1 capitalize" }
const _hoisted_5 = ["onClick"]

import { ref, PropType } from "vue";
import { User } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddPresentersInput',
  props: {
  users: {
    type: Array as PropType<User[]>,
    required: true,
  },
  presenters: {
    type: Array as PropType<String[]>,
    required: true,
  },
},
  emits: ["select", "remove"],
  setup(__props, { emit }) {

const props = __props;


const selectedPresenter = ref("");



function addPresenter() {
  if (!selectedPresenter.value) return;
  if (props.presenters.includes(selectedPresenter.value)) return;

  emit("select", selectedPresenter.value);
}

function removePresenter(index: number) {
  emit("remove", index);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        id: "presenter",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPresenter).value = $event)),
        class: "text-black border w-full rounded-l focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.users.filter(i => !__props.presenters.find(j => i.id === j)), (user) => {
          return (_openBlock(), _createElementBlock("option", {
            value: user.id,
            key: user.id
          }, _toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 9, _hoisted_2))
        }), 128)),
        (__props.users.filter(i => !__props.presenters.find(j => i.id === j)).length === 0)
          ? (_openBlock(), _createElementBlock("option", _hoisted_3, _toDisplayString(_ctx.$t("no-presenters-available")), 1))
          : _createCommentVNode("", true)
      ], 512), [
        [_vModelSelect, selectedPresenter.value]
      ]),
      _createElementVNode("button", {
        onClick: addPresenter,
        type: "button",
        class: "capitalize border rounded-r focus:outline-none focus:shadow-outline-purple font-normal transition duration-50 ease-in py-1.5 h-10 flex items-center whitespace-nowrap bg-primary active:bg-blue-600 hover:bg-blue-600 border-primary text-white disabled:bg-blue-300 disabled:border-blue-300 px-3"
      }, _toDisplayString(_ctx.$t("add-presenter")), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.presenters, (presenter, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "flex justify-between py-2 border-b border-gray-300 last:border-none"
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.users.find(i => i.id === presenter)?.first_name) + " " + _toDisplayString(__props.users.find(i => i.id === presenter)?.last_name), 1),
        _createElementVNode("button", {
          class: "text-link",
          onClick: ($event: any) => (removePresenter(index))
        }, _toDisplayString(_ctx.$t("remove")), 9, _hoisted_5)
      ]))
    }), 128))
  ]))
}
}

})